// extracted by mini-css-extract-plugin
module.exports = {"suggestionItem":"Fields-module_suggestionItem_1enPF"};